// extracted by mini-css-extract-plugin
module.exports = {"componentsPaymentMethodsGooglePay":"styles_componentsPaymentMethodsGooglePay__2hehZ"};